<template>
    <div>
        <b-form-group label="value[0]"
                      label-size="sm"
                      :label-cols-sm="1"
                      description="Set value or FDO reference">
            <JsonEditor :data-input="value[0]" @data-output="(data) => (value[0] = data)"></JsonEditor>
        </b-form-group>
        <b-form-group label="value[1]"
                      label-size="sm"
                      :label-cols-sm="1"
                      description="Set value or FDO reference">
            <JsonEditor :data-input="value[1]" @data-output="(data) => (value[1] = data)"></JsonEditor>
        </b-form-group>
    </div>
</template>

<script>
import valueCmp from "./mixins/valueCmp";

export default {
    mixins: [valueCmp],
}
</script>

<style scoped>

</style>
